(function ($, document, window) {
    'use strict';

    $(function () {
        const $title = $('.js-notice-title');

        let isDown = false;
        let startX;
        let scrollLeft;

        function handleMouseDown(e) {
            isDown = true;
            startX = e.pageX - $(this).offset().left;
            scrollLeft = $(this).scrollLeft();
        }

        function handleMouseLeave() {
            isDown = false;
        }

        function handleMouseUp() {
            isDown = false;
        }

        function handleMouseMove(e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - $(this).offset().left;
            const walk = (x - startX) * 3;
            $(this).scrollLeft(scrollLeft - walk);
        }

        function handleTouchStart(e) {
            isDown = true;
            startX = e.touches[0].pageX - $(this).offset().left;
            scrollLeft = $(this).scrollLeft();
        }

        function handleTouchEnd() {
            isDown = false;
        }

        function handleTouchMove(e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.touches[0].pageX - $(this).offset().left;
            const walk = (x - startX) * 3;
            $(this).scrollLeft(scrollLeft - walk);
        }
        
        $title.on('mousedown', handleMouseDown);
        $title.on('mouseleave', handleMouseLeave);
        $title.on('mouseup', handleMouseUp);
        $title.on('mousemove', handleMouseMove);

        $title.on('touchstart', handleTouchStart);
        $title.on('touchend', handleTouchEnd);
        $title.on('touchmove', handleTouchMove);
    });
})(jQuery, document, window);
